export enum StudentSCheduleWidgetMessage {
  SCHEDULE_TITLE = "Today's Activities",
  SCHEDULE_TITLE_FOR_BELL = 'Today’s Schedule',
  SCHEDULE_HOMEROOM = 'My Homeroom',
  SCHEDULE_BUTTON_LABEL = 'View all',
  SCHEDULE_BUTTON_LABEL_FOR_BELL = 'Full schedule',
  EMPTY_SCHEDULE_TITLE = 'Schedule not available',
  EMPTY_SCHEDULE_DESC = 'Your schedule will be visible here',
}
